<template>
	<div class="page bg-body">
		<VacationDetailInfo :data="productInfo"></VacationDetailInfo>

		<!-- 选择舱房 -->
		<div class="section">
		</div>
		<div class="main-width">
			<div class="product__container">
				<div id="product-content" ref="product_content">
					<v-sticky :offsetTop="appHeaderHeight" @change="isFixedScrollNav = $event">
						<div class="scroll-nav-wraper" :class="[isFixedScrollNav ? 'border-b' : '']" ref="scrollNavRef">
							<scroll-active class="scroll-nav" highlight-first-item tag="ul" :offset="58">
								<li class="scroll-nav-item scrollactive-item" data-section-selector=".product-features">
									产品特色
								</li>
								<li class="scroll-nav-item scrollactive-item" data-section-selector=".product-tours">
									行程介绍
								</li>
								<li class="scroll-nav-item scrollactive-item" data-section-selector=".product-fee">
									费用说明
								</li>
								<li class="scroll-nav-item scrollactive-item"
									data-section-selector=".product-booking-notice" v-if="productInfo.booking_notice.booking_notice">
									预订须知
								</li>
								<li class="scroll-nav-item scrollactive-item" data-section-selector=".product-cancel">
									取消政策
								</li>
								<li class="scroll-nav-item scrollactive-item" data-section-selector=".product-tips" v-if="productInfo.booking_notice.tips">
									温馨提示
								</li>
							</scroll-active>
							<div class="scroll-nav__material" @click="openMaterrialDiaog" v-if="productInfo.exists_material">
								<el-image class="scroll-nav__material__icon" fit="contain"
									src="@/assets/img/product/icon_product_material.png"></el-image>
								<span>营销素材</span>
								<i class="ficon ficon-arrow-right"></i>
							</div>
						</div>
					</v-sticky>
					<!-- 产品特色 -->
					<div class="section product-features">
						<div class="">
							<div class="card">
								<div class="card-title">产品特色</div>
								<div class="product-features-content" v-if="productInfo.features">
									<div :class="[featureHeight >= 400 && !showMoreFeature ? 'h-100 overflow-hidden' : '']"
										ref="featureRef">
										<editor-content normal :content="productInfo.features" />
									</div>
									<div class="product-fetures-btn mx-auto" v-if="!showMoreFeature && featureHeight >= 400"
										@click="showMoreFeature = true">
										<span>了解更多</span>
										<i class="ficon ficon-arrow-bottom"></i>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="section product-tours">
						<div class="">
							<div class="card">
								<div class="card-title">行程介绍</div>
								<template v-if="productInfo.tour.length">
									<div v-for="(tour, index) in productInfo.tour" :key="index" class="product-tour">
										<div class="product-tour-header">
											<div class="product-tour-day">Day {{ tour.day }}</div>
											<h4 class="product-tour-title">{{ tour.title }}</h4>
										</div>
										<div class="product-tour-con">
											<el-row class="product-tour-attr">
												<el-col v-if="tour.port" class="attr icon_flex" :span="6">
                          <el-image style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_port.png" fit="cover"></el-image>
                          停靠港口：{{ tour.port }}
                        </el-col>
												<el-col class="attr" :span="24">
                          <el-image v-if="tour.arrival_time || tour.leave_time" style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_time.png" fit="cover"></el-image>
                          <span v-if="tour.arrival_time" class="icon_flex">
                            抵港时间：{{ tour.arrival_time }}
                          </span>
                          <span v-if="tour.leave_time"><span class="line" v-if="tour.arrival_time && tour.leave_time">|</span>离港时间：{{ tour.leave_time }}</span>
                        </el-col>
												<!-- <el-col v-if="tour.leave_time" class="attr" :span="6">离港时间：{{
													tour.leave_time
												}}</el-col> -->
												<el-col class="attr icon_flex" :span="24" v-if="tour.check">
                          <el-image style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_check_in.png" fit="cover"></el-image>
                          入住：{{ tour.check }}
                        </el-col>
												<el-col class="attr icon_flex" :span="24">
                          <el-image v-if="tour.breakfast || tour.lunch || tour.dinner" style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_food.png" fit="cover"></el-image>
                          <span v-if="tour.breakfast">早餐：{{ tour.breakfast }}</span>
                          <span v-if="tour.lunch">
                            <span class="line" v-if="tour.breakfast">|</span>
                            午餐：{{ tour.lunch }}
                          </span>
                          <span v-if="tour.dinner">
                            <span class="line" v-if="tour.lunch || tour.breakfast">|</span>
                            晚餐：{{ tour.dinner }}
                          </span>
                        </el-col>
												<!-- <el-col class="attr" :span="24" v-if="tour.lunch">午餐：{{
													tour.lunch
												}}</el-col>
												<el-col class="attr" :span="24" v-if="tour.dinner">晚餐：{{
													tour.dinner
												}}</el-col> -->
											</el-row>
											<div class="product-tour-desc" v-if="tour.desc">
												{{ tour.desc }}
											</div>
											<el-row class="product-tour-imgs" :gutter="20" v-if="tour.images.length">
												<el-col v-for="(img, index) in tour.images" :key="index"
													class="product-tour-img" :span="8">
													<el-image class="img" fit="cover" :src="img" />
												</el-col>
											</el-row>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>

					<!-- 费用说明 -->
					<div class="section product-fee" v-if="productInfo.cost.include || productInfo.cost.not_include">
						<div class="">
							<div class="card">
								<div class="card-title">费用说明</div>
								<div class="card-body">
									<div class="product-fee-subtitle">费用包含</div>
									<div class="product-fee-content">
										<p class="whitespace-pre-line">{{ productInfo.cost.include }}</p>
									</div>
									<div class="product-fee-subtitle">费用不含</div>
									<div class="product-fee-content">
										<p class="whitespace-pre-line">{{ productInfo.cost.not_include }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 预订须知 -->
					<div class="section product-booking-notice" v-if="productInfo.booking_notice.booking_notice">
						<div class="">
							<div class="card">
								<div class="card-title">预订须知</div>
								<div class="product-booking-notice-content">
									{{ productInfo.booking_notice.booking_notice }}
								</div>
							</div>
						</div>
					</div>

					<!-- 取消政策 -->
					<div class="section product-cancel">
						<div class="">
							<div class="card">
								<div class="card-title">取消政策</div>
								<div class="product-cancel-content">
									{{ productInfo.booking_notice.cancel }}
								</div>
							</div>
						</div>
					</div>

					<!-- 温馨提示 -->
					<div class="section product-tips" v-if="productInfo.booking_notice.tips">
						<div class="">
							<div class="card">
								<div class="card-title">温馨提示</div>
								<div class="product-tips-content">
									{{ productInfo.booking_notice.tips }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="product__container__right">
					<v-affix class="fixed" relative-element-selector="#product-content"
						:offset="{ top: appHeaderHeight + 12, bottom: 0 }" :scroll-affix="false"
						@affix="affixRightPannel = true" @affixtop="affixRightPannel = false">
						<VacationRightPannel :affixd="affixRightPannel" :data="productInfo" />
					</v-affix>
				</div>
			</div>
		</div>

		<!-- dock -->
		<ProductDetailTools
			v-if="productInfo.status !== 0"
			:is-favorite="isFavorite"
			:is-open-shop="isOpenShop"
			:is-in-shop="isInShop"
			@share="handleShareShopProduct"
			@favorite="onToggleFavorite"
			@join="onJoinShop"
      :url="productInfo.mini_code"
		/>
		<!-- S 相关产品推荐 -->
		<ProductRecommond :similar="productInfo.similar" />

		<!--分享店铺产品二维码-->
		<share-shop-product ref="shareShopProduct"></share-shop-product>
		<product-material ref="productMaterialRef" />

	</div>
</template>
<script>
import VacationDetailCalendar from "@/views/product/VacationDetailCalendar.vue";
import VacationDetailBookingForm from "@/views/product/VacationDetailBookingForm.vue";
import ScrollActive from "@/components/ScrollActive";
import VAffix from "@/components/VAffix";
import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";
import VacationDetailInfo from "@/views/product/VacationDetailInfo.vue";
import VacationRightPannel from "@/views/product/VacationRightPannel.vue";
import ProductRecommond from "@/views/product/ProductRecommond.vue";
import EditorContent from "~/components/Ckeditor/EditorContent.vue";
import VSticky from '~/components/VSticky/index.vue';
import ProductDetailTools from '~/views/product/ProductDetailTools.vue'
import ProductMaterial from '@/components/product/product-material.vue'


// composables
import useProductFavorite from "@/views/product/composables/useProductFavorite.js";
import useProductJoinShop from "@/views/product/composables/useProductJoinShop.js";
import useRequest from "@/composables/useRequest";
import useVacationSotck from "@/views/product/composables/useVacationSotck.js";
import useVacationDest from "@/views/product/composables/useVacationDest.js";
import useVacationSotckPrice from "@/views/product/composables/useVacationSotckPrice.js";

import useLayout from '~/composables/useLayout'

// api
import * as VacationService from "@/services/vacation";
// import { REQUEST_CODES } from "@/constants/const-http";

// utils
import { DownloadByStreamingFile } from "@/utils/file-download";
import { head, isEmpty } from "@/utils/helpers";



import {
	defineComponent,
	useFetch,
	useMeta,
	nextTick,
	useRoute,
	toRef,
	ref,
	computed,
	useStore
} from "@nuxtjs/composition-api";
import { useElementSize } from "@vueuse/core";

function useProductInfo(productNo) {
	const {
		isLoading,
		state: productInfo,
		execute: fetchProductInfo
	} = useRequest(
		() => VacationService.getProductDetail({ product_no: productNo }),
		{
			images: [],
			cost: {},
			booking_notice: {},
			dates: {
				dates: []
			},
			tour: [],
			feature_image: []
		},
		{
			immediate: false
		}
	);

	return {
		isLoading,
		productInfo,
		fetchProductInfo
	};
}

export default defineComponent({
	name: "VacationProductDetail",
	// layout: "Main",
	layout: "Main",
	auth: false,
	validate({ params }) {
		// Must be a number
		return /P(\d|\-)+$/.test(params.productNo);
	},
	components: {
		VacationDetailCalendar,
		VacationDetailBookingForm,
		ScrollActive,
		EditorContent,
		VAffix,
		VSticky,

		ShareShopProduct,
		VacationDetailInfo,
		VacationRightPannel,
		ProductRecommond,
		ProductDetailTools,
		ProductMaterial
		// VFloatButtonGroup,
		// VFloatButton,
		// VFloatButtonBackTop,
		// ProductJoinShop
	},
	// props: {
	//   productNo: String,
	// },
	head: {},
	setup() {
		// const {isLoading, productInfo, fetchProductInfo} = useProductInfo(props.productNo)
		const route = useRoute();
		const store = useStore();
		const productNo = toRef(route.value.params, "productNo");
		const product_content = ref(null);

		const { width } = useElementSize(product_content);
		const featureRef = ref(null)
		const { height: featureHeight } = useElementSize(featureRef);

		const { isFavorite, favoriteIcon, onToggleFavorite } = useProductFavorite(
			productNo.value
		);
		const { isInShop, onJoinShop } = useProductJoinShop(productNo.value);
		const isOpenShop = computed(() => store.getters.isOpenShop);
		const { productInfo = {}, fetchProductInfo } = useProductInfo(
			productNo.value
		);

		const {
			flatStocks,
			dates,
			// monthNavs,
			selectedStock,

			fetchDate
		} = useVacationSotck(productNo.value);

		const { fetchDist, citys, meals, selectedCityId, selectedMealId } =
			useVacationDest();

		const { priceInfo, fetchPrice } = useVacationSotckPrice(
			productNo.value,
			selectedCityId,
			selectedMealId,
			selectedStock
		);
		useMeta(() => ({
			title: `${productInfo.value.product_name} ${productInfo.value.departure_city_label} ${productInfo.value.dates.total_date}个团期可定`,
			meta: [
				{
					name: "description",
					hid: "description",
					// 【上船吧】（www.shangchuanba.com），产品特色（例*高端品牌 Club Med始于1950年，是世界上最早的高端休闲品牌，Club Med不仅是品质的象征，确保您的假期安心舒适，也是您身份的彰显——尊贵体面。其独特的“一价全包”、休闲运动度假村形式、特别的G.O文化等，使其成为独…）
					content: `【上船吧】（www.shangchuanba.com），${productInfo.value.features}`
				},
				{
					name: "keywords",
					hid: "keywords",
					// content: state.value.cruises.map((cruise) => cruise.name),
					content:
						"上船吧，分销平台，产品特色，行程介绍，费用说明，预订须知，取消政策，温馨提示，费用包含，费用不含，"
				}
			]
		}));
		useFetch(async () => {
			await fetchProductInfo(0);
			isInShop.value = !!productInfo.value.in_shop;
			isFavorite.value = !!productInfo.value.is_favorite;
			// title.value = productInfo.value.product_name;

			await fetchDate(0);
			if (flatStocks.value.length) {
				selectedStock.value = head(flatStocks.value);
			}

			if (selectedStock.value) {
				await fetchDist(0, productNo.value, selectedStock.value.date);
			}

			if (!isEmpty(citys.value)) {
				selectedCityId.value = head(citys.value).city_id || "";
				selectedMealId.value = head(meals.value).id;
				await fetchPrice(0);
			}
			// title.value = `${productInfo.value.product_name} ${productInfo.value.departure_city_label} ${productInfo.value.dates.total_date}个团期可定`
			// meta.value = [
			//   {
			//     name: "description",
			//     hid: 'description',
			//     // 【上船吧】（www.shangchuanba.com），产品特色（例*高端品牌 Club Med始于1950年，是世界上最早的高端休闲品牌，Club Med不仅是品质的象征，确保您的假期安心舒适，也是您身份的彰显——尊贵体面。其独特的“一价全包”、休闲运动度假村形式、特别的G.O文化等，使其成为独…）
			//     content: `【上船吧】（www.shangchuanba.com），${productInfo.value.features}`,
			//   },
			//   {
			//     name: "keywords",
			//     hid: 'keywords',
			//     // content: state.value.cruises.map((cruise) => cruise.name),
			//     content: '上船吧，分销平台，产品特色，行程介绍，费用说明，预订须知，取消政策，温馨提示，费用包含，费用不含，'
			//   }
			// ]
		});

		// onMounted(() => {

		// });

		function onStockChange() {
			fetchDist(0, productNo.value, selectedStock.value.date).then(async () => {
				selectedCityId.value = head(citys.value).city_id;
				await nextTick(() => {
					selectedMealId.value = head(meals.value).id;
				});
				return fetchPrice(0);
			});
		}

		function onMealChange() {
			fetchPrice(0);
		}

		function onCityChange() { }

		const showMoreFeature = ref(false);


		// ======================= sticky =======================
		const { headerSize } = useLayout();
		const scrollNavRef = ref();
		const { height: scrollNavHeight } = useElementSize(scrollNavRef)
		const offsetTop = computed(() => headerSize.height + scrollNavHeight.value);
		const appHeaderHeight = computed(() => headerSize.height);
		const isFixedScrollNav = ref(false);

		// 套餐
		return {
			productNo,
			isFavorite,
			favoriteIcon,
			onToggleFavorite,
			isOpenShop,
			isInShop,
			onJoinShop,

			productInfo,

			flatStocks,
			dates,
			citys,
			meals,
			priceInfo,

			selectedCityId,
			selectedMealId,
			selectedStock,

			onStockChange,
			onMealChange,
			onCityChange,
			product_content,
			leftContWidth: width,
			featureRef,
			featureHeight,
			showMoreFeature,


			scrollNavRef,
			offsetTop,
			appHeaderHeight,
			isFixedScrollNav
		};
	},
	data() {
		return {
			tourNavCode: 0,
			affixRightPannel: false
			// visibleFeatureImg: false,
		};
	},
	computed: {
		auth() {
			return this.$auth;
		},
		loggedIn() {
			return this.auth.loggedIn;
		},
		isDistributor() {
			if (!this.auth.loggedIn) return false;
			return !!this.auth.user.distributor;
		},
		hasMaterial() {
			const { exists_file, exists_image, exists_video } = this.productInfo;
			return exists_file || exists_video || exists_image;
		}
	},
	methods: {
		//分享店铺
		handleShareShopProduct() {
			this.$refs.shareShopProduct.handleShareShopPrdouct({
				product_no: this.productInfo.product_no
			});
		},
		handleDownloadTravel() {
			let tempName = this.productInfo.product_name + ".doc";
			DownloadByStreamingFile(
				"/api/product/product/download-trip",
				{ product_no: this.productInfo.product_no },
				tempName,
				"application/msword"
			);
		},
		openMaterrialDiaog() {
			this.$refs.productMaterialRef.setData({
        product_no: this.productNo
      })
		}
	}
});
</script>
<style lang="scss" scoped>
.section {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.card {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding: 20px;
}
.card-title {
  font-size: 20px;
  line-height: 20px;
  color: var(--text-color-dark);
  font-weight: 500;
  position: relative;
}
.fixed {
  z-index: 10;
}
.fixed.affix {
  box-shadow: 0 1px 5px #e1e1e1;
}
.scroll-nav-wraper {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  margin-bottom: 0.75rem;
  position: relative;
}
.scroll-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  color: #495057;
  background: #fff;
}
.scroll-nav-item {
  border-radius: 0.125rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  padding: 20px 0;
  margin: 0 20px;
}
.scroll-nav-item.is-active {
  color: #1F2129;
  border-bottom: 3px solid currentColor;
}
.scroll-nav__material {
  position: absolute;
  display: flex;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  cursor: pointer;
  user-select: none;
}
.scroll-nav__material__icon {
  width: 39px;
  height: 31px;
  margin-right: 5px;
}
.scroll-nav__material >span {
  color: #495057;
  font-size: 14px;
}
.scroll-nav__material .ficon {
  color: #979797;
}
::v-deep .download-btn, .share-btn {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  width: 10rem;
}
::v-deep .download-btn .icon, .share-btn .icon {
  height: 2rem;
  margin-right: 10px;
  width: 1.75rem;
}
.product-action-group {
  border-radius: 9999px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 2.5rem;
  margin-left: 2rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  border: $border-base;
}
.product__container {
  display: flex;
  align-items: flex-start;
}
.product__container__right {
  width: 346px;
  margin-left: 16px;
  flex-shrink: 0;
}
.product-trip-image {
  width: 100%;
  margin-top: 18px;
}
.product-tour {
  margin-top: 18px;
}
.product-tour-header {
  position: relative;
  padding-left: 65px;
}
.product-tour-day, .product-tour-title {
  font-weight: 500;
  font-size: 18px;
}
.product-tour-day {
  position: absolute;
  left: 0;
  top: 0;
  padding: 9px 0;
  text-align: center;
  border-radius: 20px 0 0 20px;
  color: #212529;
  font-size: 16px;
  font-weight: 500;
}
.product-tour-day::after {
  content: "";
  width: 1px;
  height: 1em;
  background: #d8d8d8;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.product-tour-title {
  padding: 9px 0;
  color: $important-text-color;
}
.product-tour-con {
  margin-top: 10px;
  padding-bottom: 15px;
}
.product-tour-con::before {
  width: 1px;
  height: 100%;
  top: 0;
}
.product-tour-con::after {
  bottom: 0;
}
.product-tour-con .c-attr {
  margin-top: 12px;
}
.product-tour-con .c-attr .attr {
  margin-bottom: 4px;
}
.product-tour-con .product-tour-desc {
  white-space: pre-line;
  margin-top: 20px;
  font-size: 15px;
  line-height: 1.5;
  color: $color-grey-2;
}
.product-tour-imgs {
  margin-top: 18px;
}
.product-tour-img {
  height: 166px;
  margin: 10px 0;
}
.product-tour-img .img {
  width: 100%;
  height: 100%;
}
.product-features-content, .product-visa-content, .product-booking-notice-content, .product-cancel-content, .product-tips-content {
  margin-top: 18px;
  white-space: pre-line;
  line-height: 24px;
  color: $secondary-text-color;
}
.product-fee-subtitle {
  margin-top: 12px;
  font-weight: bold;
  color: $secondary-text-color;
}
.product-fee-content {
  line-height: 24px;
  margin-top: 5px;
}
.product-fetures-image {
  position: relative;
  margin-top: 18px;
  font-size: 0;
  padding-bottom: 50px;
}
.product-fetures-image__wrapper {
  padding-bottom: 100px;
  max-height: 500px;
  overflow: hidden;
  position: relative;
}
.product-fetures-btn {
  width: 112px;
  height: 36px;
  border-radius: 6px;
  color: #f25b3b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 1;
  cursor: pointer;
  user-select: none;
}
.product-fetures-btn .ficon {
  margin-left: 5px;
}
.tourNav {
  display: flex;
  padding: 15px 4px 5px;
  flex-wrap: wrap;
}
.tourNav__item {
  color: #495057;
  font-size: 14px;
  padding: 4px 18px;
  border-radius: 6px;
  background-color: #e9ecef;
  margin-right: 6px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
}
.tourNav__item--active {
  background-color: $highlight-color;
  color: #fff;
}
#product-content {
  flex: 1;
}
.icon_flex {
  display: flex;
  align-items: center;
}
.line {
  margin: 0 8px;
}
.common {
  display: flex;
  align-items: center;
}
</style>
